import NavigationDrawer from './NavigationDrawer/NavigationDrawer'
import { Outlet } from 'react-router-dom'

export default function TeacherLayout() {
  return (
    <div className="w-full h-full flex">
      <NavigationDrawer />
      <div className="bg-brij-Default px-10 py-6 gap-7 w-full h-full flex flex-col">
        <Outlet />
      </div>
    </div>
  )
}
